import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../styles/BottomNav.css';
import { useAuth } from '../context/AuthContext';

const TABS = [
  { to: '/swipe',    label: 'Discover', icon: '🔥' },
  { to: '/matches',  label: 'Matches',  icon: '💬' },
  { to: '/likes',    label: 'Likes',    icon: '❤️' },
  { to: '/profile',  label: 'Profile',  icon: '👤' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
];

export default function BottomNav() {
  const { user } = useAuth();

  return (
    <nav className="bottom-nav">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => `nav-tab ${isActive ? 'active' : ''}`}
        >
          <span className="nav-icon">{tab.icon}</span>
          <span className="nav-label">{tab.label}</span>
        </NavLink>
      ))}
      {(user?.role === 'admin' || user?.role === 'moderator') && (
        <Link to="/admin" className="nav-tab">
          <span className="nav-icon">⚙️</span>
          <span className="nav-label">Admin</span>
        </Link>
      )}
    </nav>
  );
}